import { sealSVG, SITE } from "@/lib/brand";

export const downloadBlob = (filename, content, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};

// Printable bookmark as a crisp vector SVG (2in x 6in @ 96dpi).
export const makeBookmarkSVG = ({ title, subtitle, affirm, c1, c2 }) => `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="192" height="576" viewBox="0 0 192 576">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/>
    </linearGradient>
    <linearGradient id="gold" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#F5D77F"/><stop offset="0.5" stop-color="#D4AF37"/><stop offset="1" stop-color="#996515"/>
    </linearGradient>
  </defs>
  <rect width="192" height="576" rx="14" fill="url(#bg)"/>
  <rect x="8" y="8" width="176" height="560" rx="10" fill="none" stroke="url(#gold)" stroke-width="2"/>
  <circle cx="96" cy="70" r="30" fill="none" stroke="url(#gold)" stroke-width="2"/>
  <text x="96" y="80" text-anchor="middle" font-family="Georgia, serif" font-weight="700" font-size="26" fill="url(#gold)">BSN</text>
  <text x="96" y="150" text-anchor="middle" font-family="Georgia, serif" font-weight="700" font-size="22" fill="#FDF8ED">${title}</text>
  <text x="96" y="178" text-anchor="middle" font-family="Georgia, serif" font-size="13" fill="#F5E7C4">${subtitle}</text>
  <line x1="40" y1="205" x2="152" y2="205" stroke="url(#gold)" stroke-width="1"/>
  ${affirm.map((line, i) => `<text x="96" y="${280 + i * 34}" text-anchor="middle" font-family="Georgia, serif" font-size="15" fill="#FFFFFF">${line}</text>`).join("")}
  <text x="96" y="520" text-anchor="middle" font-family="monospace" font-size="11" fill="#F5E7C4">Call or Text 988</text>
  ${sealSVG(32, 530, 14)}
  <text x="52" y="541" font-family="Georgia, serif" font-size="9.5" fill="#EBF4F6">brightstoriesnetwork.com</text>
</svg>`;

export const makeSafetyPlan = () => `BRIGHT STORIES NETWORK — MY SAFETY PLAN
(Keep this somewhere you will see it. You matter.)

IMMEDIATE HELP
  • 988 Suicide & Crisis Lifeline — Call or Text 988
  • Crisis Text Line — Text HOME to 741741
  • The Trevor Project — 1-866-488-7386 / Text START to 678-678
  • Emergency — 911

1. WARNING SIGNS (thoughts, feelings, situations that tell me a crisis may be building):
   ____________________________________________________________
   ____________________________________________________________

2. THINGS THAT HELP ME COPE ON MY OWN (music, walk, breathing, sanctuary sounds):
   ____________________________________________________________
   ____________________________________________________________

3. PEOPLE & PLACES THAT DISTRACT AND COMFORT ME:
   ____________________________________________________________

4. PEOPLE I CAN ASK FOR HELP (name — phone):
   ____________________________________________________________
   ____________________________________________________________

5. PROFESSIONALS / AGENCIES I CAN CONTACT:
   ____________________________________________________________

6. MAKING MY SPACE SAFER (steps to reduce access to means of harm):
   ____________________________________________________________

7. MY REASONS FOR LIVING:
   ____________________________________________________________
   ____________________________________________________________

One breath at a time. The dawn has never once failed to arrive.

— Bright Stories Network · ${SITE}
`;
